
<main id="main-page">
    <DisplayMessage />
    <div class="set-font-size">
        <div class="triple-column">
            <div>
                <Greeting />
                <Partner on:message={partnerChange} />
                <PartnerNotes />
                <AlphaGrid on:message={alphaChanged} bind:alpha/>
            </div>
            <div>
                <Pairs on:message={pairUpdated} />
            </div>
            <div class="right-panel">
                <Valediction />
                <div id="button-holder">
                    <button class="select-button" on:click={() => openPanel('chat_select')}>Chat</button>
                    <button class="select-button" on:click={() => openPanel('conventions')}>Conventions</button>
                    <button class="select-button" on:click={() => openPanel('emojis')}>Emojis</button>
                    <button class="select-button" on:click={restoreDefaults}>Restore defaults</button>
                    <button class="select-button" on:click={saveDefaults}>Save defaults</button>
                    <button class="select-button" on:click={showMaintenance}>Maintenance</button>
                    <MaintenanceButtons on:message={defaultMessage} />
                </div>
            </div>
        </div>
        <PopupMessage />
        <ConventionDisplay />
        <ChatSelect />
        <Emojis />
    </div>
</main>

<style>
    #main-page {
        display: none;
    }

    .triple-column {
        display: grid;
        grid-template-columns: auto auto auto;
        justify-content: start;
        gap: 1vw;
    }

    .right-panel {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 3vh;
    }

    #button-holder {
        display: flex;
        flex-direction: column;
    }
</style>

<script>

    import { get } from 'svelte/store';
    import DisplayMessage from "./DisplayMessage.svelte";
    import Greeting from "./Greeting.svelte";
    import Partner from "./Partner.svelte";
    import AlphaGrid from "./AlphaGrid.svelte";
    import Valediction from "./Valediction.svelte";
    import Pairs from "./Pairs.svelte";
    import MaintenanceButtons from "./MaintenanceButtons.svelte";
    import PopupMessage from "./PopupMessage.svelte";
    import PartnerNotes from "./PartnerNotes.svelte";
    import ConventionDisplay from "./ConventionDisplay.svelte";
    import ChatSelect from "./ChatSelect.svelte";
    import Emojis from "./Emojis.svelte";

    import { user, state } from './data-store.js';
    import { writeToUser } from './user.js';
    import { switchToGreeting, hideMaintenancePanels } from './common.js'
    import { elementDisplay, getStyle } from './utilities';


    let alpha = '';
    let partner = '';
    let first_names = [];
    let selected_greeting = '';
    let selected_valediction = '';

    function pairUpdated(event) {
        first_names = event.detail.players
        switchToGreeting();
    }

    function partnerChange(event) {
        partner = event.detail.partner
        get(state).system = event.detail.system_text
    }

    function defaultMessage(event) {
        switch (event.detail.action) {

            case 'save_defaults':
                default_greeting = selected_greeting
                default_valediction = selected_valediction
                $user.default_greeting = default_greeting;
                $user.default_valediction = default_valediction;
                writeToUser()
                break;

            case 'restore_defaults':
                selected_greeting = default_greeting
                selected_valediction = default_valediction
                $user.selected_greeting = selected_greeting;
                $user.selected_valediction = selected_valediction;
                writeToUser(false)
                alpha = 'All'
                switchToGreeting();
                break;

            default:
                break;
        }
    }

    function alphaChanged(event) {
        if (event && typeof(event) != 'string') {
            alpha = event.detail.text;
        }
    }

    function restoreDefaults() {
        $user.selected_greeting = $user.default_greeting;
        $user.selected_valediction = $user.default_valediction;
        $state.alpha = 'All'
        $state.message = buildMessage()
        switchToGreeting();
    }

    function saveDefaults() {
        $user.default_greeting = $user.selected_greeting;
        $user.default_valediction = $user.selected_valediction;
        writeToUser()
    }

    function showMaintenance() {
        let display = getStyle('button-panel', 'display');
        if (display == 'block') {
            elementDisplay('button-panel', 'none')
        } else {
            elementDisplay('button-panel', 'block')
        }
    }

    function openPanel(panel_name) {
        let display = getStyle(panel_name, 'display');
        hideMaintenancePanels();
        if (display == 'grid') {
            elementDisplay(panel_name, 'none')
        } else {
            elementDisplay(panel_name, 'grid')
        }
    }

</script>